import DeleteIcon from "@mui/icons-material/Delete"
import { Box, CircularProgress, DialogContentText, MenuItem } from "@mui/material"
import Button from "@mui/material/Button"
import Dialog from "@mui/material/Dialog"
import DialogActions from "@mui/material/DialogActions"
import DialogContent from "@mui/material/DialogContent"
import DialogTitle from "@mui/material/DialogTitle"
import { useAppDispatch } from "hooks"
import { useState } from "react"
import licensePoolService from "services/licensePoolService"
import { removeLicensePool } from "slices/licensePoolSlice"
import { hiabColors } from "theme"
import type { ILicensePool } from "types/licensePoolTypes"

type Props = {
  licensePool: ILicensePool
}

export function DeleteLicensePoolDialog({ licensePool }: Props) {
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const [open, setOpen] = useState(false)

  const dispatch = useAppDispatch()

  const handleClickDeleteApp = () => {
    setIsLoading(true)

    licensePoolService
      .deleteLicensePool(licensePool.id)
      .then((_resp) => {
        dispatch(removeLicensePool(licensePool))
        setIsLoading(false)
        handleClose()
      })
      .catch((err) => {
        console.log(err)
        setIsLoading(false)
      })
  }

  const handleClickOpen = () => {
    setOpen(true)
  }

  const handleClose = () => {
    setOpen(false)
  }

  return (
    <div>
      <MenuItem onClick={handleClickOpen}>
        <DeleteIcon sx={{ marginRight: 1 }} />
        Delete
      </MenuItem>
      <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
        <DialogTitle>{`Delete ${licensePool.name}`}</DialogTitle>
        <DialogContent>
          <DialogContentText>
            {`Are you sure you want to delete ${licensePool.name} license pool?`}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          <Box sx={{ m: 1, position: "relative" }}>
            <Button
              onClick={handleClickDeleteApp}
              disabled={isLoading}
              variant="contained"
              sx={{ backgroundColor: hiabColors.redPrimary }}
            >
              Delete
            </Button>
            {isLoading && (
              <CircularProgress
                size={24}
                sx={{
                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  marginTop: "-12px",
                  marginLeft: "-12px",
                }}
              />
            )}
          </Box>
        </DialogActions>
      </Dialog>
    </div>
  )
}
